import { useMemo } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { NotFound } from 'components/core-ui'

const PrivateRoute = ({ component: RouteComponent, ...props }) => {
  const location = useLocation()
  const { id } = useParams()

  const matchRoute = (appPages, currentPath) => {
    const currentPathWithReplaceId = currentPath.replace(id, ':id')
    const currentPathWithoutId = currentPath.replace(/\/\d+$/, '/:id')

    return appPages.includes(currentPathWithReplaceId) || appPages.includes(currentPathWithoutId)
  }

  const isAuthorized = useMemo(() => {
    if (props.checkIsAuthorized) {
      const isMatch = matchRoute(props.applicationPages, location.pathname)

      return isMatch
    }

    return true
  }, [location, props.applicationPages, props.checkIsAuthorized])

  return isAuthorized ? <RouteComponent {...props} /> : <NotFound />
}

export default PrivateRoute
